export const helpSystemInterface = {
    publicContent: false,
    privateContent: false,
}
